import { render, staticRenderFns } from "./bottled.vue?vue&type=template&id=197b0428&scoped=true&"
import script from "./bottled.vue?vue&type=script&lang=js&"
export * from "./bottled.vue?vue&type=script&lang=js&"
import style0 from "./bottled.vue?vue&type=style&index=0&id=197b0428&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b0428",
  null
  
)

export default component.exports